import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import SaleResultSelect from './SaleResultSelect'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import authStore from '../../Auth/AuthStore';
import mainStore from '../../../MainStore';
import SaleStore from './SaleStore';

const SaleDoneDialog = observer(class SaleDoneDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resultId: '',
            result: '',
            isNeedCreateProject: false
        };
        this.handleSave = this.handleSave.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate() {
        console.log(arguments);
    }

    handleClose() {
        SaleStore.closeSaleFinishDialog();
    }

    handleSelect(result) {
        this.setState({ resultId: result.id, result: result });
    }

    handleSave() {
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Sale/FixSaleResult', {
            method: 'POST',
            body: JSON.stringify({ saleId: SaleStore.saleId, resultId: this.state.resultId, isNeedCreateProject: this.state.isNeedCreateProject }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch(); Перезагрузить доску?
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    var sale = SaleStore.getSale;
                    sale.result = scope.state.result.name;
                    sale.resultId = scope.state.result.id;
                    sale.projectId = result.projectId;
                    sale.project = sale.caption;
                    SaleStore.setSale(sale);
                    SaleStore.closeSaleFinishDialog();
                }).catch((err) => console.log(err));
            }
        });
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.checked });
    }

    render() {
        return (
            <Dialog
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={SaleStore.isSaleDoneDialogOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleClose}>
                    Завершение продажи
                </DialogTitle>
                <DialogContent dividers>
                    <div className="sale-finish-dialog-content">
                        <Typography>
                            <SaleResultSelect label="Результат продажи" handleSelect={this.handleSelect}/>
                        </Typography>
                        {this.state.resultId === '96d2a4ba-548c-4472-9368-9b05010ce39a' && <Typography>
                            <FormControlLabel
                                control={
                                    <Checkbox disabled={SaleStore.getIsProjectExist} checked={SaleStore.getIsProjectExist || this.state.isNeedCreateProject} value="true" onChange={this.handleChange('isNeedCreateProject')} />
                                }
                                label="Создать проект"
                            />
                        </Typography>}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleSave} color="primary">
                        Сохранить
                     </Button>
                </DialogActions>
            </Dialog>
        );
    }
});

export default SaleDoneDialog;